export const LS_LOCALE = 'moovyLocale'
export const SS_TOKEN = 'moovyAuthToken'
export const SS_CUSTOMER_TYPE = 'moovyType'
export const SS_CUSTOMER_INIT = 'moovyCustomerInit'
export const SS_CUSTOMER_ID = 'moovyCustomerId'
export const SS_CUSTOMER_NAME = 'moovyCustomerName'
export const SS_PLACE_ID = 'moovyPlaceId'
export const SS_PLACE_NAME = 'moovyPlaceName'
export const SS_CATALOGUE_ID = 'moovyCatalogueId'
